/* V3 29 Sep 2026: shorts real inseam is 5" (12.7cm). Patch Kiwi chart cells until Admin chart 9572447 is updated. */
(function () {
  function patch(root) {
    if (!root || root.nodeType !== 1) return;
    var tables = root.querySelectorAll ? root.querySelectorAll('table') : [];
    tables.forEach(function (table) {
      var text = (table.innerText || '').toLowerCase();
      if (text.indexOf('inseam') === -1) return;
      if (text.indexOf('short') === -1 && text.indexOf('waist') === -1) return;
      // only patch cycle/shorts-like charts (has waist+hips+inseam, not leggings ~31")
      var cells = table.querySelectorAll('td, th');
      cells.forEach(function (cell) {
        var t = (cell.textContent || '').trim();
        if (t === '6.5' || t === '6.5"' || t === '7' || t === '7"' || t === '6.5 in' || t === '7 in') {
          cell.textContent = '5';
        } else if (/^16\.5$|^17\.8$|^16\.5 cm$|^17\.8 cm$/i.test(t)) {
          // approx cm for old 6.5"/7"
          cell.textContent = '12.7';
        } else if (t === '16.5' || t === '17.8') {
          cell.textContent = '12.7';
        }
      });
    });
  }
  function run() {
    patch(document);
    document.querySelectorAll('#KiwiSizingChart, .ks-modal, [class*="kiwi"], [id*="Kiwi"]').forEach(patch);
  }
  run();
  var obs = new MutationObserver(function () { run(); });
  if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', run);
  setTimeout(run, 1500);
  setTimeout(run, 4000);
})();
